/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SocialProfileIdentify model module.
 * @module model/SocialProfileIdentify
 * @version v1
 */
class SocialProfileIdentify {
    /**
     * Constructs a new <code>SocialProfileIdentify</code>.
     * @alias module:model/SocialProfileIdentify
     * @param email {String} MaxLength:64
     */
    constructor(email) { 
        
        SocialProfileIdentify.initialize(this, email);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email) { 
        obj['Email'] = email;
    }

    /**
     * Constructs a <code>SocialProfileIdentify</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SocialProfileIdentify} obj Optional instance to populate.
     * @return {module:model/SocialProfileIdentify} The populated <code>SocialProfileIdentify</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SocialProfileIdentify();

            if (data.hasOwnProperty('SocialProfileTypeId')) {
                obj['SocialProfileTypeId'] = ApiClient.convertToType(data['SocialProfileTypeId'], 'Number');
            }
            if (data.hasOwnProperty('Email')) {
                obj['Email'] = ApiClient.convertToType(data['Email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SocialProfileIdentify</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SocialProfileIdentify</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SocialProfileIdentify.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['Email'] && !(typeof data['Email'] === 'string' || data['Email'] instanceof String)) {
            throw new Error("Expected the field `Email` to be a primitive type in the JSON string but got " + data['Email']);
        }

        return true;
    }


}

SocialProfileIdentify.RequiredProperties = ["Email"];

/**
 * @member {Number} SocialProfileTypeId
 */
SocialProfileIdentify.prototype['SocialProfileTypeId'] = undefined;

/**
 * MaxLength:64
 * @member {String} Email
 */
SocialProfileIdentify.prototype['Email'] = undefined;






export default SocialProfileIdentify;

